// extracted by mini-css-extract-plugin
export default {"read-more":"ReadMore_read-more__zq25G","text":"ReadMore_text__V9L6w"};